import { createAction } from '@reduxjs/toolkit';
const fetchEventsRequest = createAction('events/fetchRequest');
const fetchEventsSuccess = createAction('events/fetchSuccess');

const fetchSortedEventsRequest = createAction('events/fetchSortedEventsRequest');
const fetchSortedEventsSuccess = createAction('events/fetchSortedEventsSuccess');
const clearSortedEvents = createAction('events/clearSortedEvents');

const showFetchEventsLoader = createAction('events/showFetchEventsLoader');
const hideFetchEventsLoader = createAction('events/hideFetchEventsLoader');

const cancelCanceledRequest = createAction('events/cancelCanceledRequest');
const cancelCanceledSuccess = createAction('events/cancelCanceledSuccess');

const showSuccessfulToast = createAction('events/showSuccessfulToast');
const hideSuccessfulToast = createAction('events/hideSuccessfulToast');

const setLastRequestDates = createAction('events/setLastRequestDates');
const clearLastRequestDates = createAction('events/clearLastRequestDates');

const addAppointment = createAction('events/addAppointment');
const editAppointment = createAction('events/editAppointment');

const deleteEventRequest = createAction('events/deleteEventRequest');
const deleteEventSuccess = createAction('events/deleteEventSuccess');

const showDeleteEventToast = createAction('events/showDeleteEventToast');
const hideDeleteEventToast = createAction('events/hideDeleteEventToast');

const fetchPaymentRequest = createAction('events/fetchPaymentRequest');
const fetchPaymentSuccess = createAction('events/fetchPaymentSuccess');

const showPaymentToast = createAction('events/showPaymentToast');
const hidePaymentToast = createAction('events/hidePaymentToast');

const rewriteEventsStart = createAction('events/rewriteEventsStart');
const rewriteEventsEnd = createAction('events/rewriteEventsEnd');

const fetchMultiPaymentRequest = createAction('events/fetchMultiPaymentRequest');
const fetchMultiPaymentSuccess = createAction('events/fetchMultiPaymentSuccess');

const showMultiPaymentToast = createAction('events/showMultiPaymentToast');
const hideMultiPaymentToast = createAction('events/hideMultiPaymentToast');

const showRruleSheet = createAction('events/showRruleSheet');
const hideRruleSheet = createAction('events/hideRruleSheet');

const setRruleEventData = createAction('events/setRruleEventData');
const clearRruleEventData = createAction('events/clearRruleEventData');

const changeEventRequest = createAction('events/changeEventRequest');
const changeEventSuccess = createAction('events/changeEventSuccess');

const changeEventStartLoader = createAction('events/changeEventStartLoader');
const changeEventStopLoader = createAction('events/changeEventStopLoader');

const changeEventShowUndoToast = createAction('events/changeEventShowUndoToast');
const changeEventHideUndoToast = createAction('events/changeEventHideUndoToast');

const fetchAllWorkersEventsRequest = createAction('events/fetchAllWorkersEventsRequest');
const fetchAllWorkersEventsSuccess = createAction('events/fetchAllWorkersEventsSuccess');

export default {
  fetchAllWorkersEventsRequest,
  fetchAllWorkersEventsSuccess,
  changeEventShowUndoToast,
  changeEventHideUndoToast,
  changeEventStartLoader,
  changeEventStopLoader,
  setRruleEventData,
  clearRruleEventData,
  clearSortedEvents,
  fetchSortedEventsRequest,
  fetchSortedEventsSuccess,
  fetchMultiPaymentRequest,
  fetchMultiPaymentSuccess,
  showMultiPaymentToast,
  hideMultiPaymentToast,
  fetchPaymentRequest,
  fetchPaymentSuccess,
  showPaymentToast,
  hidePaymentToast,
  addAppointment,
  editAppointment,
  showFetchEventsLoader,
  hideFetchEventsLoader,
  showDeleteEventToast,
  hideDeleteEventToast,
  deleteEventRequest,
  deleteEventSuccess,
  fetchEventsRequest,
  fetchEventsSuccess,
  setLastRequestDates,
  clearLastRequestDates,
  rewriteEventsStart,
  rewriteEventsEnd,
  cancelCanceledRequest,
  cancelCanceledSuccess,
  showSuccessfulToast,
  hideSuccessfulToast,
  showRruleSheet,
  hideRruleSheet,
  changeEventRequest,
  changeEventSuccess,
};
